import { api, headers } from "./api";

const RESOURCE = 'tahun';

export const getsTahunAkademik = () => api.get(RESOURCE, headers);